import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError, timeout  } from 'rxjs';
import { shareReplay, catchError, tap, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
//import { RegistroCandidatoRequestInterface } from '../interfaces/candidato/registro-candidato-request.interface';
import { RegistroCandidatoRequestInterface } from 'src/app/core/interfaces/candidato/registro-candidato-request.interface';
import { AuthApiService } from 'src/app/core/services/auth-api-service';
import { EncryptionService } from './encryption.service';

@Injectable({
  providedIn: 'root'
})
export class CandidatosApiService {
  user$ = this.authApiService.getUser();
  private tokenKey = 'authToken';
  private isAuthenticated = new BehaviorSubject<boolean>(this.hasToken());

  constructor(private http: HttpClient, private authApiService: AuthApiService, private encryptionService: EncryptionService) { }

  private hasToken(): boolean {
    return !!localStorage.getItem(this.tokenKey);
  }

  postGeneraCodigoSeguridad(email: string): Observable<any> {
    let _data = {
      "email": email
    };
    return this.http
      .post<any>(`${environment.apiCandidatos}/v1/genera-codigo-de-seguridad`, _data)
      .pipe(shareReplay(1))
  }

  postValidacionCodigoSeguridad(email: string, codigo: number): Observable<any> {
    let _data = {
      "codigo": codigo,
      "email": email
    };
    return this.http
      .post<any>(`${environment.apiCandidatos}/v1/validar-codigo-de-seguridad`, _data)
      .pipe(shareReplay(1))
  }

  postRegistorContacto(registroCandidatoRequest: RegistroCandidatoRequestInterface): Observable<any> {
    const _password: string = registroCandidatoRequest.datos_personales.password || '';
    registroCandidatoRequest.datos_personales.password = this.encryptionService.encryptToBase64(_password);
    return this.http
      .post<RegistroCandidatoRequestInterface>(`${environment.urlApiCandidato}/user/agregaUsuario`, registroCandidatoRequest)
      .pipe(shareReplay(1))
  }

  getInformacionCandidato(): Observable<any> {
    let _request: any = {};
    this.user$.subscribe(user => {
      _request = {
        "uid": user?.uid,
        "email": user?.email
      };
    });
    
    return this.http
      .post<{ token: any, data: any }>(`${environment.urlApiCandidato}/user/consultaUsuario`, _request)
      .pipe(shareReplay(1))
  }

  validarEmailExistenteCandidato(email: string): Observable<any> {
    return this.http
      .get<{ token: any, data: any }>(`${environment.urlApiCandidato}/user/validaCorreo?email=${encodeURIComponent(email)}`)
      .pipe(shareReplay(1))
  }

  validateCURPService(curp: string): Observable<any> {
    return this.http
      .get<{ token: any, data: any }>(`${environment.urlApiCandidato}/user/validaCurp?curp=${curp}`)
      .pipe(shareReplay(1))
  }

  validatePhoneNumberService(telefono: string): Observable<any> {
    return this.http
      .get<{ token: any, data: any }>(`${environment.urlApiCandidato}/user/validaTelefono?telefono=${telefono}`)
      .pipe(shareReplay(1))
  }

  passwordResetService(numeroEtapaFront: string, email: string): Observable<{codigo: string, estatus: boolean, mesanje: string}> {
    let _request: any = { 
      "email":email,
      "link":`${environment.urlResetPasswordValidator}`
    };
    return this.http
      .post<{codigo: string, estatus: boolean, mesanje: string}>(`${environment.urlApiCandidato}/user/solicitudReseteo`, _request)
      .pipe(shareReplay(1))
  }

  validateCodeResetPasswordService(email: string, token: string): Observable<{codigo: string, estatus: boolean, mesanje: string}> {
    let _request: any = { 
      "email":email,
      "codigo": token
    };
    return this.http
      .post<{codigo: string, estatus: boolean, mesanje: string}>(`${environment.urlApiCandidato}/user/validarCodigo`, _request)
      .pipe(shareReplay(1))
  }

  resetPasswordService(email: string, password: string, token: string): Observable<{codigo: string, estatus: boolean, mesanje: string}> {
    let _request: any = { 
      "email":email,
      "password": this.encryptionService.encryptToBase64(password),
      "codigo": token
    };
    return this.http
      .post<{codigo: string, estatus: boolean, mesanje: string}>(`${environment.urlApiCandidato}/user/actualizaPassword`, _request)
      .pipe(shareReplay(1))
  }

  actualizarCandidato(candidatoRequest: RegistroCandidatoRequestInterface): Observable<any> {
    let _request: any = {};
    this.user$.subscribe(user => {
      candidatoRequest.datos_personales.uid = user?.uid;
    });
    const _password: string = candidatoRequest.datos_personales.password || '';
    candidatoRequest.datos_personales.password = this.encryptionService.encryptToBase64(_password);

    return this.http
      .post<RegistroCandidatoRequestInterface>(`${environment.urlApiCandidato}/user/actualizaUsuario`, candidatoRequest)
      .pipe(shareReplay(1))
  }

  postularCandidato(idPosicion: number, idCandidato: number): Observable<any> {

    ////id candidato traerlo del storage una vez que se recupera del servicio 
    /// https://manpowermexico-dev.appiancloud.com/suite/webapi/obtener-resume?idCandidato=737  || idCandidato=737 || correo=asd@as.as || proceso_id=737
  const url = `${environment.urlAppian}/asociar-candidato`; // Usa tu proxy configurado
  
  const body = {
    idPosicion,
    idCandidato
  };

  const headers = new HttpHeaders({ 'appian-api-key': environment.appianApiKey, 'Content-Type': 'application/json', 'Accept': 'application/json' });

  console.log('📤 Enviando POST a asociar-candidato:', body);

  return this.http.post<any>(url, body, { headers, responseType: 'text' as 'json' }).pipe(
    tap(response => {
      console.log('✅ Respuesta asociar-candidato:', response)
      return response;
    }),
    catchError(error => {
      console.error('❌ Error en asociar-candidato:', error);
      return throwError(() => error);
    })
  );
}


  cargaImagenCandidato(imagenBase64: string): Observable<any> {
    let _request: any = {
      "uid":"",//Id usuario
      "imagen": imagenBase64
    };
    this.user$.subscribe(user => {
      _request.uid = user?.uid;
    });

    return this.http
      .post<RegistroCandidatoRequestInterface>(`${environment.urlApiCandidato}/user/subirImagen`, _request)
      .pipe(shareReplay(1))
  }

  getImagenCandidato(): Observable<any> {
    let _request: any = {
      "uid":"",
    };
    this.user$.subscribe(user => {
      _request.uid = user?.uid;
    });

    return this.http
      .get<RegistroCandidatoRequestInterface>(`${environment.urlApiCandidato}/user/descargaImagen?uid=${_request.uid}`, _request)
      .pipe(shareReplay(1))
  }

  obtieneVacantesPostuladas(): Observable<any> {
    let _uid: string = '';
    this.user$.subscribe(user => {
      _uid = user?.uid || '';
    });
    return this.http
      .get<any>(`${environment.urlApiCandidato}/user/obtenerPostulaciones?uid=${_uid}&numRegistros=3`)
      .pipe(shareReplay(1))
  }

  agregarExperienciaLaboral(empresa: string, fechaInicio: string, fechaFin: string, puesto: string, actividades: string, idSalario: number): Observable<any> {
    let _request: any = [{
            "uid": "",
            "uem_empresa": empresa,
            "uem_id_area_org": 15,
            "uem_anio_ini": this.obtenerMesYAnio(fechaInicio).mes,
            "uem_mes_ini": this.obtenerMesYAnio(fechaInicio).anio,
            "uem_anio_fin": this.obtenerMesYAnio(fechaFin).mes,
            "uem_mes_fin": this.obtenerMesYAnio(fechaFin).anio,
            "uem_posicion": puesto,
            "uem_id_rango_sueldo": idSalario,
            "uem_responsabilidades": actividades,
            "uem_id_pais": "MX"
        }];

    this.user$.subscribe(user => {
      _request[0].uid = user?.uid;
    });

    return this.http
      .post<RegistroCandidatoRequestInterface>(`${environment.urlApiCandidato}/user/agregaExperiencia`, _request)
      .pipe(shareReplay(1))
  }

  getExperienciaLaboral(): Observable<any> {
    let _uid: string = '';
    this.user$.subscribe(user => {
      _uid = user?.uid || '';
    });

    return this.http
      .get<any>(`${environment.urlApiCandidato}/user/obtenerExperiencia?pais=MX&uid=${_uid}`)
      .pipe(shareReplay(1))
  }

  actualizarExperienciaLaboral(empresa: string, fechaInicio: string, fechaFin: string, puesto: string, actividades: string, idSalario: number, idEmpresa: number): Observable<any> {
    let _request = [
      {
        "uem_id_empresa": idEmpresa,
        "uid": '',
        "uem_empresa": empresa,
        "uem_id_sector": 11,
        "uem_posicion": puesto,
        "uem_id_area_org": 32,
        "uem_anio_ini": this.obtenerMesYAnio(fechaInicio).mes,
        "uem_mes_ini": this.obtenerMesYAnio(fechaInicio).anio,
        "uem_anio_fin": this.obtenerMesYAnio(fechaFin).mes,
        "uem_mes_fin": this.obtenerMesYAnio(fechaFin).anio,
        "uem_id_rango_sueldo": idSalario,
        "uem_responsabilidades": actividades,
        "uem_id_pais": "MX"
      }
    ];

    this.user$.subscribe(user => {
      _request[0].uid = user?.uid || '';
    });

    return this.http
      .post<any>(`${environment.urlApiCandidato}/user/actualizaExperiencia`, _request)
      .pipe(shareReplay(1))
  }

  eliminarExperienciaLaboral(idExperiencia: number): Observable<any> {
    const _idExperienciaEncrypt = this.encryptionService.encryptToBase64(idExperiencia.toString());

    let _request = {
      "idUsuario": "",
      "idEmpresa": _idExperienciaEncrypt
    }

    this.user$.subscribe(user => {
      _request.idUsuario = user?.uid || '';
    });

    return this.http
      .post<any>(`${environment.urlApiCandidato}/user/eliminaExperiencia`, _request)
      .pipe(shareReplay(1))
  }



  obtieneDescripcionPuestoAI(archivo: File): Observable<any> {
    // Si useProxy es true y urlAppian es relativa, usar proxy, sino usar URL completa
    let baseUrl: string;
    if (environment.useProxy && environment.urlAppian.startsWith('/')) {
      baseUrl = `${environment.urlAppian}/upload_cv_portal`;
    } else {
      // En producción o sin proxy, usar siempre urlAppianUploadCvPortal
      baseUrl = environment.urlAppianUploadCvPortal;
    }
    const url = `${baseUrl}?clave=&portal=1`;
    
    console.log('📤 URL upload_cv_portal configurada:', {
      useProxy: environment.useProxy,
      urlAppian: environment.urlAppian,
      urlAppianUploadCvPortal: environment.urlAppianUploadCvPortal,
      baseUrl,
      urlFinal: url
    });
    // Normalizar nombre del archivo
    const safeHeaderValue = archivo.name.normalize('NFC').replace(/[\u0000-\u001F]/g, '');
    const nombreAscii = safeHeaderValue.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    
    // Enviar el archivo como binario directo (como --data-binary en curl)
    const headers = new HttpHeaders({
      'appian-api-key': environment.appianApiKey,
      'Appian-Document-Name': nombreAscii,
      'Content-Type': archivo.type || 'application/octet-stream'
    });
    
    console.log('🚀 Enviando archivo como binario directo al API de Appian (fallback):', {
      fileName: archivo.name,
      fileSize: archivo.size,
      contentType: archivo.type,
      apiKey: (environment.appianApiKey || '').substring(0, 20) + '...',
      url
    });
    
    return this.http
      .post(url, archivo, {headers, responseType: 'text', observe: 'response'})
      .pipe( timeout(120000), map((res: any) => {
          const bodyText = res.body ?? '';
          // Extrae proceso_id: NNNN del texto que devuelve Appian
          const match = String(bodyText).match(/proceso_id\s*:\s*(\d+)/i);
          const procesoId = match ? Number(match[1]) : null;
          // Guarda en localStorage si existe
          localStorage.setItem('proceso_id', procesoId?.toString() ?? '0');
          console.log('✅ Respuesta Appian (binario directo):', bodyText);
          console.log('🆔 proceso_id extraído:', procesoId);
          return { raw: bodyText, procesoId };
        }),
        catchError(error => {
          console.error('❌ Error API directo:', error);
          if (error.name === 'TimeoutError') {
            console.error('⏱️ La solicitud de carga de CV excedió el tiempo de espera');
          } else if (error.status === 401) {
            console.error('🔑 Error de autenticación - Token inválido o expirado');
          } else if (error.status === 415) {
            console.error('⚠️ Tipo de contenido no soportado. Verifica el Content-Type del archivo');
          } else {
            console.error('🚨 Error al cargar CV:', error);
          }
          return throwError(() => error);
        })
      );
  }
  /*obtieneDescripcionPuestoAI(archivo: File): Observable<any> {
    // Crear FormData para enviar el archivo
    const formData = new FormData();
    formData.append('Appian-Document-Name', archivo, archivo.name);

    // Headers con la API key de Appian - usando diferentes formatos por si hay problemas
    const headers = new HttpHeaders({
            'appian-api-key': environment.appianApiKey,
            'Accept': 'application/json'
          });

    // Usar proxy para evitar CORS (ajusta la URL según tu configuración de proxy)
    const url = `${environment.urlAppianUploadCvPortal}?clave=&portal=1`;
    
    console.log('🚀 Enviando archivo al API de Appian:', {
      fileName: archivo.name,
      fileSize: archivo.size,
      url: url,
      headers: headers.keys()
    });
    
    return this.http
      .post<any>(url, formData, { headers, responseType: 'text' as 'json' })
      .pipe(
        timeout(120000), // Tiempo en milisegundos (120 segundos)
        tap(response => {
          console.log('✅ Respuesta exitosa del API de Appian:', response);
          return response;
        }),
        catchError(error => {
          console.error('❌ Error completo del API:', error);
          if (error.name === 'TimeoutError') {
            console.error('La solicitud de carga de CV excedió el tiempo de espera');
          } else if (error.status === 401) {
            console.error('Error de autenticación - Token inválido o expirado');
          } else {
            console.error('Error al cargar CV:', error);
          }
          return throwError(() => error);
        })
      );
  }*/

  // Método alternativo usando URL directa (en caso de que no uses proxy)
  obtieneDescripcionPuestoAIDirecto(archivo: File): Observable<{ raw: string; procesoId: number | null }> {
    // Si useProxy es true y urlAppian es relativa, usar proxy, sino usar URL completa
    let baseUrl: string;
    if (environment.useProxy && environment.urlAppian.startsWith('/')) {
      baseUrl = `${environment.urlAppian}/upload_cv_portal`;
    } else {
      // En producción o sin proxy, usar siempre urlAppianUploadCvPortal
      baseUrl = environment.urlAppianUploadCvPortal;
    }
    const url = `${baseUrl}?clave=&portal=1`;
    
    console.log('📤 URL upload_cv_portal (directo) configurada:', {
      useProxy: environment.useProxy,
      urlAppian: environment.urlAppian,
      urlAppianUploadCvPortal: environment.urlAppianUploadCvPortal,
      baseUrl,
      urlFinal: url
    });
    // Normalizar nombre del archivo
    const safeHeaderValue = archivo.name.normalize('NFC').replace(/[\u0000-\u001F]/g, '');
    const nombreAscii = safeHeaderValue.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    
    // Enviar el archivo como binario directo (como --data-binary en curl)
    const headers = new HttpHeaders({
      'appian-api-key': environment.appianApiKey,
      'Appian-Document-Name': nombreAscii,
      'Content-Type': archivo.type || 'application/octet-stream'
    });
    
    console.log('🚀 Enviando archivo como binario directo al API de Appian:', {
      fileName: archivo.name,
      fileSize: archivo.size,
      contentType: archivo.type,
      apiKey: (environment.appianApiKey || '').substring(0, 20) + '...',
      url
    });
    
    return this.http
      .post(url, archivo, {headers, responseType: 'text', observe: 'response'})
      .pipe( timeout(120000), map((res: any) => {
          const bodyText = res.body ?? '';
          // Extrae proceso_id: NNNN del texto que devuelve Appian
          const match = String(bodyText).match(/proceso_id\s*:\s*(\d+)/i);
          const procesoId = match ? Number(match[1]) : null;
          // Guarda en localStorage si existe
          localStorage.setItem('proceso_id', procesoId?.toString() ?? '0');
          console.log('✅ Respuesta Appian (binario directo):', bodyText);
          console.log('🆔 proceso_id extraído:', procesoId);
          return { raw: bodyText, procesoId };
        }),
        catchError(error => {
          console.error('❌ Error API directo:', error);
          if (error.name === 'TimeoutError') {
            console.error('⏱️ La solicitud de carga de CV excedió el tiempo de espera');
          } else if (error.status === 401) {
            console.error('🔑 Error de autenticación - Token inválido o expirado');
          } else if (error.status === 415) {
            console.error('⚠️ Tipo de contenido no soportado. Verifica el Content-Type del archivo');
          } else {
            console.error('🚨 Error al cargar CV:', error);
          }
          return throwError(() => error);
        })
      );
  }
  /*obtieneDescripcionPuestoAIDirecto(archivo: File, nameDocument: string): Observable<any> {
    const formData = new FormData();
    formData.append('Appian-Document-Name', archivo, archivo.name);
    const url = `${environment.urlAppianUploadCvPortal}?clave=&portal=1`;
    const headers = new HttpHeaders({
      'appian-api-key': environment.appianApiKey,
    });

    console.log('🚀 Enviando archivo DIRECTAMENTE al API de Appian:', {
      fileName: archivo.name,
      fileSize: archivo.size,
      apiKey: environment.appianApiKey.substring(0, 20) + '...'
    });

    return this.http
      .post<any>(url, formData, { headers, responseType: 'text' as 'json' })
      .pipe(
        timeout(120000),
        tap(response => {
          console.log('✅ Respuesta exitosa del API de Appian (directo):', response);
          return response
        }),
        catchError(error => {
          console.error('❌ Error API directo:', error);
          if (error.name === 'TimeoutError') {
            console.error('La solicitud de carga de CV excedió el tiempo de espera');
          } else if (error.status === 401) {
            console.error('Error de autenticación - Token inválido o expirado');
          } else {
            console.error('Error al cargar CV:', error);
          }
          return throwError(() => error);
        })
      );
  }*/

  // Utilerías
  obtenerMesYAnio(fecha: string): { mes: number, anio: number } {
    if (fecha === '') {
      return { mes: 0, anio: 0};
    }
    // Ejemplo de uso:
    // const resultado = obtenerMesYAnio("05-2024");
    // console.log(resultado); // { mes: 5, anio: 2024 }

    const [mesStr, anioStr] = fecha.split("-");
    const mes = parseInt(mesStr, 10);
    const anio = parseInt(anioStr, 10);

    if (isNaN(mes) || isNaN(anio)) {
      throw new Error("Formato de fecha inválido. Se espera 'MM-YYYY'");
    }

    return { mes, anio };
  }
 

  obtenCandidato(id:any): Observable<any> {
    let url = `${environment.urlAppian}/obtener-resume`;
    const headers = new HttpHeaders({
      'appian-api-key': environment.appianApiKey,
      'Accept': 'application/json'
    });
    const params = new HttpParams().set('idCandidato', id);
    //const params = new HttpParams().set('correo', id);


    console.log('🔍 Obteniendo candidato por ID:', id);

    return this.http.get<any>(url, { headers, params }).pipe(
      map((res:any) => {
        // Normaliza "no encontrado" en distintos escenarios
        const isEmptyObj = res && typeof res === 'object' && Object.keys(res).length === 0;
        const isEmptyArr = Array.isArray(res) && res.length === 0;
        if (!res || isEmptyObj || isEmptyArr) {
          return { error: true, message: 'no se encontro el candidato' };
        }
        
        // Si es un array, tomar el primer elemento
        if (Array.isArray(res) && res.length > 0) {
          return res[0];
        }
        
        return res;
      }),
      tap(response => {
        console.log('✅ Candidato obtenido:', response);
      }),
      catchError(error => {
        console.error('❌ Error en obtenCandidato:', error);
        return throwError(() => error);
      })
    );
  }

  // Método para guardar candidato en Appian (JSON completo)
  guardarCandidatoAppian(data:any): Observable<any> {
    let url = `${environment.urlAppian}/actualizar-resume`;
    const headers = new HttpHeaders({
      'appian-api-key': environment.appianApiKey,
      'Accept': 'application/json'
    });

    return this.http.post<any>(url, data,{ headers }).pipe(
      map((res:any) => {
        return res;
      }),
      catchError(error => {
        console.error('❌ Error en guardarCandidato:', error);
        return throwError(() => error);
      })
    );
  }

  // Método para guardar candidato en Appian (JSON completo)
  guardarCandidato(candidatoData: any): Observable<any> {
    const url = `/api/appian/guardar-resume`;
    const headers = new HttpHeaders({
      'appian-api-key': environment.appianApiKey,
      'Content-Type': 'application/json',
    });

    console.log('💾 Guardando candidato en Appian:', candidatoData);

    return this.http.post<any>(url, candidatoData, { headers }).pipe(
      tap(response => {
        console.log('✅ Candidato guardado exitosamente en Appian:', response);
      }),
      catchError(error => {
        console.error('❌ Error al guardar candidato en Appian:', error);
        return throwError(() => error);
      })
    );
  }

}